module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/default-city.39a2559b7f2f73283e23be6f1f45b0be.png";